/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Disabled_Alert_DescriptionInputs */



/**
* | output |
* | --- |
* | "Compliance pattern monitoring is currently disabled. Enable it in settings to start monitoring sensitive content." |
*
* @param {Compliance_Disabled_Alert_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_disabled_alert_description = /** @type {((inputs?: Compliance_Disabled_Alert_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Disabled_Alert_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Compliance-Musterüberwachung ist derzeit deaktiviert. Aktivieren Sie sie in den Einstellungen, um mit der Überwachung sensibler Inhalte zu beginnen.")
	return /** @type {LocalizedString} */ ("Compliance pattern monitoring is currently disabled. Enable it in settings to start monitoring sensitive content.")
});